import React from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import { alpha } from "@mui/system/colorManipulator";
import { palette, sxStyles } from "./Teaser.style";
const Teaser = ({ sx, Icon, title, children, className, action = null, variant = "outlined", }) => (React.createElement(Card, { className: className, sx: {
        backgroundColor: (theme) => `${palette(theme)[variant].backgroundColor}`,
        color: (theme) => `${palette(theme)[variant].textColor}`,
        ...sx,
    } },
    React.createElement(CardHeader, { sx: (theme) => sxStyles(theme).header, avatar: React.createElement(Avatar, { sx: (theme) => ({
                ...sxStyles(theme).icon,
                backgroundColor: (theme) => alpha(`${palette(theme)[variant].iconBackgroundColor}`, +`${palette(theme)[variant].iconBackgroundColorAlpha}`),
                color: (theme) => `${palette(theme)[variant].iconColor}`,
            }) }, Icon), action: action }),
    React.createElement(CardContent, { sx: (theme) => sxStyles(theme).content },
        title ? React.createElement(Box, { sx: (theme) => sxStyles(theme).title }, title) : null,
        children)));
export default Teaser;
//# sourceMappingURL=Teaser.js.map